import { createRoot } from "react-dom/client";
import { ErrorBoundary, reactErrorHandler } from "@sentry/react";
import App from "./App.tsx";
import "./index.css";
import { initSentry } from "@/integrations/sentry/init-sentry";
import { sentryErrorFallbackRender } from "@/integrations/sentry/sentry-error-fallback";

initSentry();

createRoot(document.getElementById("root")!, {
  onRecoverableError: reactErrorHandler(),
}).render(
  <ErrorBoundary fallback={sentryErrorFallbackRender}>
    <App />
  </ErrorBoundary>,
);
